import { mustBeAdmin, mustBeSuperAdmin, redirectAdmin } from '@/middlewares';

export const globalRoutes = () => [
  {
    path: '/auth',
    component: () => import('./layout/auth/wrapper.vue'),
    meta: {
      auth: {
        redirectGuest: { name: 'dashboard' },
      },
    },
    children: [
      {
        name: 'login',
        path: 'login',
        component: () => import('./pages/auth/login.vue'),
      },
    ],
  },
];

export const protectedRoutes = () => [
  // main page
  {
    name: 'dashboard',
    path: '/',
    meta: {
      middleware: [
        redirectAdmin({ name: 'admin.users.index' }),
      ],
    },
  },
  // profile
  {
    name: 'admin.profile.index',
    path: '/admin/profile',
    component: () => import('./pages/admin/profile/index'),
    meta: {
      middleware: [mustBeAdmin],
    },
  },
  // admin users
  {
    name: 'admin.admin_users.index',
    path: '/admin/admin-users',
    component: () => import('./pages/admin/admin-users/index'),
    meta: {
      middleware: [mustBeAdmin],
    },
  },
  {
    name: 'admin.admin_users.create',
    path: '/admin/admin-users/create',
    component: () => import('./pages/admin/admin-users/manage'),
    meta: {
      middleware: [mustBeAdmin, mustBeSuperAdmin],
    },
  },
  {
    name: 'admin.admin_users.edit',
    path: '/admin/admin-users/:id/edit',
    component: () => import('./pages/admin/admin-users/manage'),
    props: true,
    meta: {
      middleware: [mustBeAdmin, mustBeSuperAdmin],
    },
  },
  // admin
  {
    name: 'admin.users.index',
    path: '/admin/users',
    component: () => import('./pages/admin/users/index'),
    meta: {
      middleware: [mustBeAdmin],
    },
  },
  {
    name: 'admin.promo.index',
    path: '/admin/promos',
    component: () => import('./pages/admin/promos/index'),
    meta: {
      middleware: [mustBeAdmin],
    },
  },
  {
    name: 'admin.promo.create',
    path: '/admin/promos/create',
    component: () => import('./pages/admin/promos/manage'),
    meta: {
      middleware: [mustBeAdmin],
    },
  },
  {
    name: 'admin.promo.edit',
    path: '/admin/promos/:id/edit',
    component: () => import('./pages/admin/promos/manage'),
    props: true,
    meta: {
      middleware: [mustBeAdmin],
    },
  },
  {
    name: 'admin.custom-referrals.index',
    path: '/admin/custom-referrals',
    component: () => import('./pages/admin/custom-referrals/index'),
    meta: {
      middleware: [mustBeAdmin],
    },
  },
  {
    name: 'admin.custom-referrals.create',
    path: '/admin/custom-referrals/create',
    component: () => import('./pages/admin/custom-referrals/manage'),
    meta: {
      middleware: [mustBeAdmin],
    },
  },
  {
    name: 'admin.custom-referrals.edit',
    path: '/admin/custom-referrals/:id/edit',
    component: () => import('./pages/admin/custom-referrals/manage'),
    props: true,
    meta: {
      middleware: [mustBeAdmin],
    },
  },
  {
    name: 'admin.api-key.index',
    path: '/admin/api-keys',
    component: () => import('./pages/admin/api-keys/index'),
    meta: {
      middleware: [mustBeAdmin],
    },
  },
  {
    name: 'admin.api-key.edit',
    path: '/admin/api-keys/:id/edit',
    component: () => import('./pages/admin/api-keys/manage'),
    props: true,
    meta: {
      middleware: [mustBeAdmin],
    },
  },
  {
    name: 'admin.referrals.index',
    path: '/admin/referrals',
    component: () => import('./pages/admin/referrals/index'),
    meta: {
      middleware: [mustBeAdmin],
    },
  },
  {
    name: 'admin.feature-flags.index',
    path: '/admin/feature-flags',
    component: () => import('./pages/admin/feature-flags/index'),
    meta: {
      middleware: [mustBeAdmin],
    },
  },
  {
    name: 'admin.feature-flags.create',
    path: '/admin/feature-flags/create',
    component: () => import('./pages/admin/feature-flags/manage'),
    meta: {
      middleware: [mustBeAdmin],
    },
  },
  {
    name: 'admin.feature-flags.edit',
    path: '/admin/feature-flags/:id/edit',
    component: () => import('./pages/admin/feature-flags/manage'),
    props: true,
    meta: {
      middleware: [mustBeAdmin],
    },
  },
  {
    name: 'admin.feature-flag-groups.index',
    path: '/admin/feature-flag-groups',
    component: () => import('./pages/admin/feature-flag-groups/index'),
    meta: {
      middleware: [mustBeAdmin],
    },
  },
  {
    name: 'admin.feature-flag-groups.create',
    path: '/admin/feature-flag-groups/create',
    component: () => import('./pages/admin/feature-flag-groups/manage'),
    meta: {
      middleware: [mustBeAdmin],
    },
  },
  {
    name: 'admin.feature-flag-groups.edit',
    path: '/admin/feature-flag-groups/:id/edit',
    component: () => import('./pages/admin/feature-flag-groups/manage'),
    props: true,
    meta: {
      middleware: [mustBeAdmin],
    },
  },
  {
    name: 'admin.validation-logs.index',
    path: '/admin/validation-logs',
    component: () => import('./pages/admin/validation-logs/index'),
    meta: {
      middleware: [mustBeAdmin],
    },
  },
  {
    name: 'admin.eskola-errors.index',
    path: '/admin/eskola-errors',
    component: () => import('./pages/admin/eskola-errors/index'),
    meta: {
      middleware: [mustBeAdmin],
    },
  },
  {
    name: 'admin.features.index',
    path: '/admin/features',
    component: () => import('./pages/admin/features/index'),
    meta: {
      middleware: [mustBeAdmin],
    },
  },
  {
    name: 'admin.features.create',
    path: '/admin/features/create',
    component: () => import('./pages/admin/features/manage.vue'),
    meta: {
      middleware: [mustBeAdmin],
    },
  },
  {
    name: 'admin.features.edit',
    path: '/admin/features/:id/edit',
    component: () => import('./pages/admin/features/manage.vue'),
    props: true,
    meta: {
      middleware: [mustBeAdmin],
    },
  },
  {
    name: 'admin.voting-event.index',
    path: '/admin/voting-events',
    component: () => import('./pages/admin/voting-events/index'),
    meta: {
      middleware: [mustBeAdmin],
    },
  },
  {
    name: 'admin.voting-event.create',
    path: '/admin/voting-events/create',
    component: () => import('./pages/admin/voting-events/manage.vue'),
    meta: {
      middleware: [mustBeAdmin],
    },
  },
  {
    name: 'admin.voting-event.edit',
    path: '/admin/voting-events/:id/edit',
    component: () => import('./pages/admin/voting-events/manage.vue'),
    props: true,
    meta: {
      middleware: [mustBeAdmin],
    },
  },
  {
    name: 'admin.api-calls.index',
    path: '/admin/api-calls',
    component: () => import('./pages/admin/api-calls/index.vue'),
    meta: {
      middleware: [mustBeAdmin],
    },
  },
  {
    name: 'admin.new-users-statistics.index',
    path: '/admin/new-users-statistics',
    component: () => import('./pages/admin/new-users-statistics/index'),
    meta: {
      middleware: [mustBeAdmin],
    },
  },
  {
    name: 'admin.churned-users-statistics.index',
    path: '/admin/churned-users-statistics',
    component: () => import('./pages/admin/churned-users-statistics/index'),
    meta: {
      middleware: [mustBeAdmin],
    },
  },
  {
    name: 'admin.users-company-statistics.index',
    path: '/admin/users-company-statistics',
    component: () => import('./pages/admin/users-company-statistics/index'),
    meta: {
      middleware: [mustBeAdmin],
    },
  },
  {
    name: 'admin.revenue-statistics.index',
    path: '/admin/revenue-statistics',
    component: () => import('./pages/admin/revenue-statistics/index'),
    meta: {
      middleware: [mustBeAdmin],
    },
  },
  {
    name: 'admin.okredo-api.index',
    path: '/admin/okredo-api',
    component: () => import('./pages/admin/okredo-api/index'),
    meta: {
      middleware: [mustBeAdmin],
    },
  },
  {
    name: 'admin.export-logs.index',
    path: '/admin/export-logs',
    component: () => import('./pages/admin/export-logs/index'),
    meta: {
      middleware: [mustBeAdmin],
    },
  },
  {
    name: 'admin.subscription-events.index',
    path: '/admin/subscription-events',
    component: () => import('./pages/admin/subscription-events/index'),
    meta: {
      middleware: [mustBeAdmin],
    },
  },
  {
    name: 'empty',
    path: '/empty',
    component: () => import('./pages/empty'),
  },
];
